export const VIEW_WIDTH = 1280;
export const VIEW_HEIGHT = 640;
